export default __webpack_public_path__ + "static/media/download_icon.0f08294c.svg";